// extracted by mini-css-extract-plugin
export default {"emailOrPhonePinPreferenceInputContainer":"email-or-phone-pin-preference-input__email-or-phone-pin-preference-input-container__bOonF"};